export default __webpack_public_path__ + "static/media/FH_olUvaQAAeGtZ.5f5393df.jpg";